import {
  cardHeader,
  ellipsisOverflow,
  tableHeadFont,
} from "~/assets/jss/globalStyle";

const roleCell = {
  ...tableHeadFont,
  ...ellipsisOverflow,
  fontSize: "12px",
  minWidth: "150px",
  maxWidth: "200px",
  paddingRight: 0,
  position: "sticky" as const,
  top: 0,
  zIndex: 2,
  backgroundColor: "white",
};

// eslint-disable-next-line
const companyRoleFeaturesStyle = (theme, props) => ({
  root: {
    margin: "16px 0",
  },
  header: {
    margin: "0 0 0 22px",
    ...cardHeader,
  },
  propertyHeader: {
    marginTop: "0px",
  },
  paperWrapper: {
    paddingTop: "16px",
  },
  scrollContainer: {
    overflow: "auto",
    maxHeight: "calc(80vh - 130px)",
  },
  table: {
    minWidth: 700,
  },

  textField: {
    width: "400px",
    margin: "0 0 16px 16px",
  },
  propertyCell: {
    ...tableHeadFont,
    width: "235px",
    color: "black",
    paddingRight: 0,
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 3,
    backgroundColor: "white",
  },
  roleCell: {
    ...roleCell,
    "&:nth-child(7)": {
      borderLeft: "solid 1px rgba(224, 224, 224, 1)",
    },
  },
  roleCellApprove: {
    ...roleCell,
    "&:nth-child(8)": {
      borderLeft: "solid 1px rgba(224, 224, 224, 1)",
    },
  },
});

export default companyRoleFeaturesStyle;
